// extracted by mini-css-extract-plugin
export default {"root":"will-you_root__hkvVf","card":"will-you_card__hUYrM","inner":"will-you_inner__D5xsQ","loser":"will-you_loser__xumgY","role":"will-you_role__5tRIY"};